export function BusinessSkeleton() {

    function render() {
        return /*html*/`
        <div class="grid xl:gap-3">
            <div class="feedbox-card border flex-col flex bg-white text-gray-800 shadow-sm rounded-xl has-[:checked]:border-[#7BB2FA] dark:bg-neutral-900 dark:border-neutral-700 dark:shadow-neutral-700/70 dark:has-[:checked]:border-[#7BB2FA]">
                <div class="p-3 md:p-4">
                    <div class="flex animate-pulse">
                        <div class="shrink-0">
                            <span class="size-12 block bg-gray-200 rounded-full dark:bg-neutral-700"></span>
                        </div>

                        <div class="ms-4 mt-2 w-full">
                            <p class="h-4 bg-gray-200 rounded-full dark:bg-neutral-700" style="width: 40%;"></p>

                            <ul class="mt-5 space-y-3">
                            <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-neutral-700"></li>
                            <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-neutral-700"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="feedbox-card border flex-col flex bg-white text-gray-800 shadow-sm rounded-xl has-[:checked]:border-[#7BB2FA] dark:bg-neutral-900 dark:border-neutral-700 dark:shadow-neutral-700/70 dark:has-[:checked]:border-[#7BB2FA]">
                <div class="p-3 md:p-4">
                    <div class="flex animate-pulse">
                        <div class="shrink-0">
                            <span class="size-12 block bg-gray-200 rounded-full dark:bg-neutral-700"></span>
                        </div>

                        <div class="ms-4 mt-2 w-full">
                            <p class="h-4 bg-gray-200 rounded-full dark:bg-neutral-700" style="width: 40%;"></p>

                            <ul class="mt-5 space-y-3">
                            <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-neutral-700"></li>
                            <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-neutral-700"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="feedbox-card border flex-col flex bg-white text-gray-800 shadow-sm rounded-xl has-[:checked]:border-[#7BB2FA] dark:bg-neutral-900 dark:border-neutral-700 dark:shadow-neutral-700/70 dark:has-[:checked]:border-[#7BB2FA]">
                <div class="p-3 md:p-4">
                    <div class="flex animate-pulse">
                        <div class="shrink-0">
                            <span class="size-12 block bg-gray-200 rounded-full dark:bg-neutral-700"></span>
                        </div>

                        <div class="ms-4 mt-2 w-full">
                            <p class="h-4 bg-gray-200 rounded-full dark:bg-neutral-700" style="width: 40%;"></p>

                            <ul class="mt-5 space-y-3">
                            <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-neutral-700"></li>
                            <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-neutral-700"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="rounded-b-lg overflow-hidden py-4 mb-[-16px] dark:border-neutral-700">
                <div class="flex animate-pulse">
                    <button disabled
                        class="w-full h-10 py-2 px-3 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
                    </button>
                </div>
            </div>
        </div>
        `;
    }

    return {
        render,
    };
}
